import React from 'react';

/**
 * Skeleton loader component for the projects overview
 * Provides visual feedback while dashboard stats are loading
 */
const ProjectsOverviewSkeleton = () => {
  return (
    <div className="projects-overview projects-overview-skeleton">
      {/* Title Skeleton */}
      <div className="skeleton-overview-title" />

      {/* Section Title Skeleton */}
      <div className="skeleton-section-title" />

      {/* Stats Grid Skeleton */}
      <div className="stats-grid">
        {[1, 2, 3, 4].map((index) => (
          <div key={index} className="stat-card skeleton-stat-card">
            <div className="stat-content">
              <div className="skeleton-stat-label" />
              <div className="skeleton-stat-value" />
            </div>
            <div className="skeleton-stat-icon" />
          </div>
        ))}
      </div>

      {/* Chart Section Title Skeleton */}
      <div className="skeleton-section-title" />

      {/* Chart Skeleton */}
      <div className="charts-section">
        <div className="chart-container skeleton-chart-container">
          {/* Y-axis labels skeleton */}
          <div className="skeleton-chart-y-axis">
            {[60, 45, 30, 15, 0].map((val) => (
              <div key={val} className="skeleton-y-label" />
            ))}
          </div>
          {/* Chart bars skeleton */}
          <div className="skeleton-chart-bars">
            {[65, 45, 80, 30, 55].map((height, index) => (
              <div
                key={index}
                className="skeleton-bar"
                style={{ height: `${height}%` }}
              />
            ))}
          </div>
          {/* X-axis labels skeleton */}
          <div className="skeleton-chart-x-axis">
            {[1, 2, 3, 4, 5].map((index) => (
              <div key={index} className="skeleton-x-label" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectsOverviewSkeleton;
